import { client } from 'core/graphql/client';
import { MeDocument } from 'core/graphql/generated/hooks';
import type { MeQuery } from 'core/graphql/generated/hooks';
import { accessSuspendedVar, authState } from 'core/state';

import { transformLmsAccess } from './transform';

/**
 * Синхронная проверка «доступ приостановлен» для кода вне рендера (ТЗ 0074):
 * флаг errorLink или закешированный `me` с блоком. Нужна обработчикам ошибок
 * страниц — чтобы `LMS_ACCESS_SUSPENDED` вёл на /invoices, а не на /error.
 */
export const isLmsAccessSuspendedNow = (): boolean => {
  if (accessSuspendedVar()) {
    return true;
  }
  try {
    const cached = client.readQuery<MeQuery>({ query: MeDocument });
    return transformLmsAccess(cached?.me, authState().active_role ?? null).isBlocked;
  } catch (e) {
    return false;
  }
};
